import { Route, Switch } from 'react-router'

import ExploreTable from './ExploreTable'
import MapV2Route from './Mapv2'
import { ViewsProvider } from './components/Views/ViewsProvider'

export default function HighSchoolsRoutes() {
  const ROOT_PATH = import.meta.env.BASE_URL

  return (
    <div>
      <Switch>
        <Route
          path={`${ROOT_PATH}/recruit/highschools`}
          exact
          render={() => (
            <ViewsProvider>
              <ExploreTable />
            </ViewsProvider>
          )}
        />
        <Route
          exact
          path={`${ROOT_PATH}/recruit/highschools/map`}
          render={() => (
            <ViewsProvider>
              <MapV2Route />
            </ViewsProvider>
          )}
        />
      </Switch>
    </div>
  )
}
